import { Alert } from "@itandi/itandi-bb-ui/Alert";
import { FormControl } from "@itandi/itandi-bb-ui/FormControl";
import { FormControlText } from "@itandi/itandi-bb-ui/FormControlText";
import { Grid } from "@itandi/itandi-bb-ui/Grid";
import { InputText } from "@itandi/itandi-bb-ui/InputText";
import type React from "react";
import { useFormContext } from "react-hook-form";
import type { VendorManagementCompanySetting } from "~/models/VendorManagementCompanySetting";

export const VendorManagementCompanySettingForm: React.FC = () => {
	const { register, formState } =
		useFormContext<VendorManagementCompanySetting>();
	const { errors } = formState;
	const noteWithinVendorPlaceholder =
		"社内で共有したいメモの雛形を記載してください\n進行中の案件では実施会社に共有されます";
	return (
		<Grid gap={16}>
			<Alert variant="info">
				改行、URLはマークダウンで記載可能です。
				<br />
				改行は半角スペース2つ、URLは[リンク名](URL)で記載可能です。
			</Alert>
			<FormControl
				isInvalid={!!errors.cautionaryNote}
				label="注意事項"
				variant="vertical"
			>
				<InputText
					maxRows={20}
					placeholder="管理会社様にお伝えしたい注意事項を記載してください"
					resize="autoRows"
					rows={8}
					{...register("cautionaryNote")}
				/>
				<FormControlText error={errors.cautionaryNote?.message} />
			</FormControl>
			<FormControl
				isInvalid={!!errors.noteWithinVendor}
				label="案件メモ"
				variant="vertical"
			>
				<InputText
					maxRows={20}
					placeholder={noteWithinVendorPlaceholder}
					resize="autoRows"
					rows={8}
					{...register("noteWithinVendor")}
				/>
				<FormControlText error={errors.noteWithinVendor?.message} />
			</FormControl>
			<FormControl
				isInvalid={!!errors.noteTemplate}
				label="共有案件メモ"
				variant="vertical"
			>
				<InputText
					maxRows={20}
					placeholder="案件メモの新規入力時に利用されるテンプレートです。"
					resize="autoRows"
					rows={8}
					{...register("noteTemplate")}
				/>
				<FormControlText error={errors.noteTemplate?.message} />
			</FormControl>
		</Grid>
	);
};
